/**
 * TODO: We can use the error from the form context,
 * I think error.root
 */

import useTranslation from "@babackapp/translations/use-translation";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { Button } from "@babackapp/ui/components/button";
import { useState } from "react";

type AuthErrorInfo = {
  message: string;
  code?: string;
  status?: number;
};

type FormGlobalErrorProps = {
  title?: string;
  error?: string | AuthErrorInfo;
  email?: string;
  onResendVerification?: (email: string) => Promise<{
    message: string;
    verificationEmailSent: boolean;
  }>;
};

export default function FormGlobalError({
  title,
  error,
  email,
  onResendVerification,
}: FormGlobalErrorProps) {
  const t = useTranslation();
  const [isResending, setIsResending] = useState(false);

  const errorMessage = error
    ? typeof error === 'string'
      ? error
      : error.message
    : null;

  const showResendButton = error &&
    typeof error === 'object' &&
    error.code === 'AUTH_EMAIL_NOT_VERIFIED' &&
    email &&
    onResendVerification;

  const handleResendVerification = async () => {
    if (!email || !onResendVerification) return;

    setIsResending(true);
    try {
      await onResendVerification(email);
    } catch (err) {
      console.error('Failed to resend verification:', err);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="bg-destructive/5 border-destructive border p-4 rounded-lg flex gap-4 items-center">
      <ExclamationTriangleIcon className="text-destructive w-6 h-6" />
      <div className="flex flex-col gap-1 flex-1">
        <span className="text-destructive font-semibold text-base">
          {title ?? t("misc.error")}
        </span>
        {errorMessage && (
          <span className="text-destructive text-sm font-medium">{errorMessage}</span>
        )}
        {showResendButton && (
          <div className="mt-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleResendVerification}
              disabled={isResending}
            >
              {isResending ? "Loading..." : "Resend verification"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
